var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteForever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99998 12.6667C3.99998 13.4 4.59998 14 5.33331 14H10.6666C11.4 14 12 13.4 12 12.6667V6C12 5.26667 11.4 4.66667 10.6666 4.66667H5.33331C4.59998 4.66667 3.99998 5.26667 3.99998 6V12.6667ZM6.11331 7.44667C6.37331 7.18667 6.79331 7.18667 7.05331 7.44667L7.99998 8.39333L8.94665 7.44667C9.20665 7.18667 9.62665 7.18667 9.88665 7.44667C10.1466 7.70667 10.1466 8.12667 9.88665 8.38667L8.93998 9.33333L9.88665 10.28C10.1466 10.54 10.1466 10.96 9.88665 11.22C9.62665 11.48 9.20665 11.48 8.94665 11.22L7.99998 10.2733L7.05331 11.22C6.79331 11.48 6.37331 11.48 6.11331 11.22C5.85331 10.96 5.85331 10.54 6.11331 10.28L7.05998 9.33333L6.11331 8.38667C5.85331 8.13333 5.85331 7.70667 6.11331 7.44667ZM10.3333 2.66667L9.85998 2.19333C9.73998 2.07333 9.56665 2 9.39331 2H6.60665C6.43331 2 6.25998 2.07333 6.13998 2.19333L5.66665 2.66667H3.99998C3.63331 2.66667 3.33331 2.96667 3.33331 3.33333C3.33331 3.7 3.63331 4 3.99998 4H12C12.3666 4 12.6666 3.7 12.6666 3.33333C12.6666 2.96667 12.3666 2.66667 12 2.66667H10.3333Z",
    fill: "#E65C64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteForever);
export default __webpack_public_path__ + "static/media/delete-forever.bcdbd218ae30b5c2d37ec263fa23cb34.svg";
export { ForwardRef as ReactComponent };